module.exports = __webpack_public_path__ + "img/newbg_b.4bb67a25.png";